import logger from '../utils/logger';
import device from '../utils/device';

let deviceInfo = null;

device.get().then(r => {
  deviceInfo = r;
});

/* global PRODUCTION */
if (PRODUCTION) {
  logger.hook(console, {
    getContext: () => {
      return deviceInfo;
    },
    getCurrentPage: () => {
      return window.location.pathname;
    }
  });
}

export default logger;



// WEBPACK FOOTER //
// ./src/app/logger.js